<template>
  <Wrapper>
    <Loading v-if="isLoading"></Loading>
    <NotEnglish v-if="isEnglishNotAvailable"></NotEnglish>
    <NotJapanese v-if="isJapaneseNotAvailable"></NotJapanese>
    <BadRequest :lang="lang" v-if="isBadRequest"></BadRequest>
    <main
      class="main"
      v-if="
        !isLoading &&
        !isEnglishNotAvailable &&
        !isJapaneseNotAvailable &&
        !isBadRequest
      "
    >
      <ol class="breadcrumb-trail__list">
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{ path: `/${langPath}` }"
            class="breadcrumb-trail__list--item__link"
          >
            TOP
          </router-link>
        </li>
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{ path: `/${langPath}event/${eventId}` }"
            class="breadcrumb-trail__list--item__link"
          >
            {{ eventData.name }}
          </router-link>
        </li>
      </ol>
      <div class="main__title">
        <h1
          class="main__title--name"
          :style="`border-left: solid 8px ${eventData.text.event_color_code};`"
        >
          {{ eventData.name }}
        </h1>
        <figure class="main__title--figure">
          <img
            :src="`https://tmf-virtualrun.jp/images/${eventData.text.image_file_name}`"
            alt=""
            height="52px"
          />
        </figure>
      </div>
      <ul class="event-category-label__list margin-top25">
        <li class="event-category-label__list--item">
          {{ eventData.text.event_label }}
        </li>
      </ul>
      <p
        class="event-description"
        v-html="eventData.text.detail_description"
      ></p>
      <p class="event-description update-time">{{
        eventData.text.update_day
      }}</p>
      <ul class="requirements-list">
        <li class="requirements-list__item">
          <dl class="requirements-list__item--dl">
            <dt class="item-team">
              {{ Event.name[lang] }}
            </dt>
            <dd class="detail-description">
              {{ eventData.name }}
            </dd>
          </dl>
        </li>
        <template v-if="eventData.texts">
          <li
            class="requirements-list__item"
            v-for="(detail, index) in eventData.texts[0].details"
            :key="index"
          >
            <dl class="requirements-list__item--dl">
              <dt class="item-team" v-html="detail.label"></dt>
              <dd class="detail-description" v-html="detail.value"></dd>
            </dl>
          </li>
        </template>
      </ul>
      <!-- エントリー対応 -->
      <!-- TODO Entry文言をコンテンツで付与して渡すことが望ましい -->
      <template v-if="isEntryLink && !eventData.text.entry_page_flag">
        <a
          v-for="(url, index) of eventData.text.entry_page_url_list"
          :key="`first-${index}`"
          :href="`${url}`"
          class="more-link icon-target-blank"
          target="_blank"
          rel="noopener"
        >
          <template v-if="eventData.text.event_name_list">
            {{ eventData.text.event_name_list[index] }}<br />
            Entry
          </template>
          <template v-else> Entry</template>
        </a>
      </template>
      <template v-else>
        <div
          v-for="(url, index) of eventData.text.entry_page_url_list"
          :key="`second-${index}`"
          class="more-link icon-target-blank gray-out"
        >
          <template v-if="eventData.text.event_name_list">
            {{ eventData.text.event_name_list[index] }}<br />
            Entry
          </template>
          <template v-else> Entry</template>
        </div>
      </template>
      <!-- ランキング対応 -->
      <router-link
        :to="{
          path: `/${langPath}${teamEventCode ? 'company/' : ''}ranking`,
          query: {
            event: `${teamEventCode ? teamEventCode : eventId}`,
            page: 1,
          },
        }"
        class="more-link"
        v-if="isResultLink"
      >
        View Result
      </router-link>
      <div class="more-link gray-out" v-else> View Result </div>
      <!-- OAuth対応 -->
      <!-- TODO 後でリファクタ必須（コンポーネントに分割するなど） -->
      <template v-if="isOauthLink">
        <div>
          {{ Event.settlement[lang] }}
        </div>
        <!-- 複数 -->
        <template v-if="eventData.text.event_name_list">
          <router-link
            v-for="(id, index) of eventData.text.event_id_list"
            :key="`third-${index}`"
            :to="{
              path: `/${langPath}confirmation`,
              query: { event: eventId, multi_event: id },
            }"
            class="more-link text-center"
          >
            {{ eventData.text.event_name_list[index] }}<br />
            {{ Event.link[lang] }}
          </router-link>
        </template>
        <!-- 単体 -->
        <template v-else>
          <router-link
            v-for="(id, index) of eventData.text.event_id_list"
            :key="`force-${index}`"
            :to="{
              path: `/${langPath}${
                teamEventCode ? 'company/' : ''
              }confirmation`,
              query: { event: `${teamEventCode ? teamEventCode : eventId}` },
            }"
            class="more-link text-center"
          >
            {{ Event.link[lang] }}
          </router-link>
        </template>
      </template>
      <!-- 期間外 -->
      <template v-else>
        <div
          v-for="(id, index) of eventData.text.event_id_list"
          :key="`fifth-${index}`"
          class="more-link text-center gray-out"
        >
          <template v-if="eventData.text.event_name_list">
            {{ eventData.text.event_name_list[index] }}<br />
            {{ Event.link[lang] }}
          </template>
          <template v-else>{{ Event.link[lang] }}</template>
        </div>
      </template>
      <RttmPartner
        v-if="eventData.name.includes('ROAD TO TOKYO MARATHON')"
        :lang="lang"
      ></RttmPartner>
      <VirtualTokyoMarathonPartner
        v-if="
          eventData.name.includes('バーチャル東京マラソン2021') ||
          eventData.name.includes('VIRTUAL TOKYO MARATHON 2021')
        "
        :lang="lang"
      ></VirtualTokyoMarathonPartner>
      <VirtualTokyoMarathon2022Partner
        v-if="
          eventData.name.includes('バーチャル東京マラソン2022') ||
          eventData.name.includes('VIRTUAL TOKYO MARATHON 2022')
        "
        :lang="lang"
      ></VirtualTokyoMarathon2022Partner>
      <VirtualTokyoMarathon2023Partner
        v-if="
          eventData.name.includes('バーチャル東京マラソン2023') ||
          eventData.name.includes('VIRTUAL TOKYO MARATHON 2023')
        "
        :lang="lang"
      ></VirtualTokyoMarathon2023Partner>
      <VirtualTokyoMarathon2024Partner
        v-if="
          eventData.name.includes('バーチャル東京マラソン2024') ||
          eventData.name.includes('VIRTUAL TOKYO MARATHON 2024')
        "
        :lang="lang"
      ></VirtualTokyoMarathon2024Partner>
      <VirtualTokyoMarathon2025Partner
        v-if="
          eventData.name.includes('バーチャル東京マラソン2025') ||
          eventData.name.includes('VIRTUAL TOKYO MARATHON 2025')
        "
        :lang="lang"
      ></VirtualTokyoMarathon2025Partner>
      <VirtualTokyoMarathon2026Partner
        v-if="
          eventData.name.includes('バーチャル東京マラソン2026') ||
          eventData.name.includes('VIRTUAL TOKYO MARATHON 2026')
        "
        :lang="lang"
      ></VirtualTokyoMarathon2026Partner>
      <VirtualTokyoLegacyHalfMarathon2022Partner
        v-if="
          eventData.name.includes('バーチャル東京レガシーハーフマラソン2022') ||
          eventData.name.includes('VIRTUAL TOKYO LEGACY HALF MARATHON 2022')
        "
        :lang="lang"
      ></VirtualTokyoLegacyHalfMarathon2022Partner>
      <VirtualMGC2023Partner
        v-if="
          eventData.name.includes(
            'バーチャルマラソングランドチャンピオンシップ（VIRTUAL MGC）'
          )
        "
        :lang="lang"
      ></VirtualMGC2023Partner>
    </main>
  </Wrapper>
</template>

<script>
import Wrapper from "../../../../components/sp/Wrapper";
import Loading from "../../../../components/sp/Loading";
import BadRequest from "../../../../components/common/status/BadRequest";
import NotEnglish from "../../../../components/sp/NotEnglish";
import NotJapanese from "../../../../components/sp/NotJapanese.vue";
import RttmPartner from "../../../../components/sp/RttmPartner";
import VirtualTokyoMarathonPartner from "../../../../components/sp/VirtualTokyoMarathonPartner";
import VirtualTokyoMarathon2022Partner from "../../../../components/sp/VirtualTokyoMarathon2022Partner";
import VirtualTokyoMarathon2023Partner from "../../../../components/sp/VirtualTokyoMarathon2023Partner";
import VirtualTokyoMarathon2024Partner from "../../../../components/sp/VirtualTokyoMarathon2024Partner";
import VirtualTokyoMarathon2025Partner from "../../../../components/sp/VirtualTokyoMarathon2025Partner";
import VirtualTokyoMarathon2026Partner from "../../../../components/sp/VirtualTokyoMarathon2026Partner";
import VirtualTokyoLegacyHalfMarathon2022Partner from "../../../../components/sp/VirtualTokyoLegacyHalfMarathon2022Partner";
import VirtualMGC2023Partner from "../../../../components/sp/VirtualMGC2023Partner";
import Event from "../../../../assets/constants/event/event";
import { RepositoryFactory } from "../../../../api/RepositoryFactory";

export default {
  data() {
    return {
      eventData: {},
      isLoading: true,
      eventId:
        this.$route.path.split("/")[1] === "en"
          ? this.$route.path.split("/")[3]
          : this.$route.path.split("/")[2],
      isEntryLink: false,
      isOauthLink: false,
      isResultLink: false,
      isEnglishNotAvailable: false,
      isJapaneseNotAvailable: false,
      isBadRequest: false,
    };
  },
  async created() {
    // イベント詳細を取得
    const EventRepository = RepositoryFactory.get("event");
    const params = {
      code:
        this.$route.path.split("/")[1] === "en"
          ? this.$route.path.split("/")[3]
          : this.$route.path.split("/")[2],
      lang: this.lang,
    };
    let response;
    try {
      response = await EventRepository.getEvent(params);
    } catch (e) {
      if (e.response.status === 400) {
        this.isBadRequest = true;
        this.isLoading = false;
      }
      return;
    }
    this.eventData = response.data;

    // Entry期間
    this.isEntryLink = this.eventData.text.entry_date_flag;
    // OAuth期間
    this.isOauthLink = this.eventData.text.oauth_date_flag;
    // ランキング
    this.isResultLink = this.eventData.text.result_date_flag;
    // 紐づくチーム対抗イベント
    this.teamEventCode = this.eventData.text.team_event_code;

    // 英語ページの場合表示するかを判定
    if (this.lang === "en" && this.eventData.text.english_page_flag) {
      this.isEnglishNotAvailable = true;
    }

    // 日本語ページの場合表示するかを判定
    if (this.lang === "ja" && this.eventData.text.japanese_page_flag) {
      this.isJapaneseNotAvailable = true;
    }

    this.isLoading = false;
  },
  computed: {
    Event: function () {
      return Event;
    },
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  components: {
    Wrapper,
    Loading,
    BadRequest,
    NotEnglish,
    NotJapanese,
    RttmPartner,
    VirtualTokyoMarathonPartner,
    VirtualTokyoMarathon2022Partner,
    VirtualTokyoMarathon2023Partner,
    VirtualTokyoMarathon2024Partner,
    VirtualTokyoMarathon2025Partner,
    VirtualTokyoMarathon2026Partner,
    VirtualTokyoLegacyHalfMarathon2022Partner,
    VirtualMGC2023Partner,
  },
  name: "Event",
};
</script>

<style scoped>
.main {
  &__title {
    margin: 40px 0 0 0;
    display: flex;
    align-items: center;
    &--name {
      line-height: 1.25;
      padding: 0 0 0 15px;
      font-size: 24px;
      font-weight: 900;
    }
  }
  .event-description {
    margin: 25px 0 0 0;
    line-height: 1.7;
    font-size: 14px;
    font-weight: 500;
  }
  .update-time {
    text-align: right;
  }
  .requirements-list {
    margin: 25px 0 40px 0;
    border-top: solid 1px var(--grayColor3);
    border-left: solid 1px var(--grayColor3);
    border-right: solid 1px var(--grayColor3);
    &__item {
      &--dl {
        .item-team {
          padding: 20px;
          border-bottom: solid 1px var(--grayColor3);
          line-height: 1.2;
          font-size: 24px;
          font-weight: bold;
          background-color: var(--defaultGrayColor);
        }

        .detail-description {
          padding: 20px;
          border-bottom: solid 1px var(--grayColor3);
          line-height: 1.5;
          font-size: 16px;
          font-weight: 500;
        }
      }
    }
  }
  .more-link {
    margin: 0 0 40px 0;
    padding: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: solid 1px var(--defaultBlackColor);
    font-size: 20px;
    font-weight: 500;
    color: var(--defaultBlackColor);
  }
  .gray-out {
    border: solid 1px var(--grayColor4);
    color: var(--grayColor4);
  }
  .icon-target-blank {
    background: url("../../../../assets/images/target-blank.svg") no-repeat
      right 20px center;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/sp/event/detail/Event.vue